// Native
import { useState } from "react"
import { Button, Separator, Stack, Text } from "@chakra-ui/react"

// Custom
import { Form, UI } from "components"
import { API, toaster } from "config"
import useUser from "hooks/useUser"

export default function Support(){

    const user = useUser()
    const [ loading, setLoading ] = useState(false)

    const handleSupport = () => {
        setLoading('support')

        setTimeout(() => {
            setLoading(false)
            window.open(`https://api.whatsapp.com/send?phone=556299555388&text=Preciso%20de%20ajuda`)
        }, 2000)
    }

    const handleChangeOption = async (support_access) => {
        setLoading('option')

        try{
            await API.put('/options', {  field: 'support_remote', value: support_access })
            toaster.create({ title: 'A configuração do suporte foi alterada', type: 'success' })
            user.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível alterar a configuração', type: 'warning' })
        }

        setLoading(false)
    }
    return(
    <UI.Box>
        <Stack gap={4}>
            <Text color="GrayText">Suporte:</Text>

            <UI.Lottie animation="support" options={{ loop: true }} style={{ height: '180px', transform: 'scale(1.2)' }} />

            <Button colorPalette="green" defaultChecked={user.data?.options?.support_remote} loading={loading==='support'} loadingText="Iniciando suporte..." onClick={handleSupport}><UI.Icon name="support" /> Falar com o suporte</Button>

            <Separator />

            <Form.Checkbox disabled={loading==='option'} defaultChecked={user.data?.options?.support_remote === true} colorPalette="green" label="Permitir que o suporte acesse meu escritório para melhor atendimento." onChange={e => handleChangeOption(e.target.checked)} />
        </Stack>
    </UI.Box>
    )
}